export default ({ error, helpText, label, ...props }) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block pb-1 text-gray-700 text-sm w-full">
          {label}
        </label>
      )}
      <input
        className={`block border p-2 rounded w-full ${
          error ? 'border-red-500' : ''
        }`}
        {...props}
      />
      {error && (
        <div className="block py-1 text-red-500 text-sm w-full">{error}</div>
      )}
      {helpText && (
        <div className="py-2 text-gray-500 text-sm w-full">{helpText}</div>
      )}
    </div>
  )
}
